import React from "react";
import GridContainer from "../../../../components/Grid/GridContainer";
import GridItem from "../../../../components/Grid/GridItem";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";

/**
 * @return {null}
 */
function CustomFields({ ...props }) {
  const customFieldsConvert =
    props.customFields !== null && props.customFields !== undefined ? JSON.parse(props.customFields) : null;

  return props.customFields ? (
    <GridContainer>
      <GridItem md={4}>
        <TranslationWrapper tDefault={"Customfields"} tKey={"bestellingen.modal.detail.customfields"} />
      </GridItem>
      <GridItem md={8}>
        {Object.keys(customFieldsConvert).map((prop, key) => {
          return (
            <p key={key}>
              <b>{prop}</b>: {customFieldsConvert[prop]}
            </p>
          );
        })}
      </GridItem>
    </GridContainer>
  ) : null;
}

export default CustomFields;
